import React, { useEffect, useState } from 'react';
import { GetPriceList } from '../../../server/PriceList';
import { Container, Row, Col } from 'react-grid-system';
import { useSelector } from 'react-redux';
import { setPrice, getSails } from '../../../server/Product';
import FamilyChangeDialog from './FamilyChangeDialog'
import './ComparePricePopUp.scss'

const ComparePricePopUp = ({ product, setComparePricePopUp }) => {
  const [keepProfitMargin, setKeepProfitMargin] = useState(false);
  const [sellingPrice, setSellingPrice] = useState("");
  const [showPopUp, setShowPopUp] = useState(false);

  const { stationId, selectedProduct } = useSelector(state => ({
    stationId: state.user.stationId,
    selectedProduct: state.selectedProduct.product
  }));

  if (!product && selectedProduct) {
    product = selectedProduct;
  }

  useEffect(() => {
    getCompareData();
    if (product?.Price !== undefined) {
      setSellingPrice(product.Price);
    }
    return () => {
      if (setComparePricePopUp) {
        setComparePricePopUp();
      }
    };
  }, [product?.Price]);


  const getCompareData = () => {
    GetPriceList(product.Mkt, product.Barcode, stationId)
      .then(x => {
        if (x.data.obj[0]?.Price !== undefined) {
          setSellingPrice(x.data.obj[0].Price);
        }
      }).catch(() => console.log("error"));
  };


  const handleSellingPriceChange = (value) => {
    if(product.Category.at(-1)?.IsFamily)
      setShowPopUp(true);
    else
      changePrice([product], value);
  };

  const handleSellingPriceClick = () => {
  if(product.Category.at(-1)?.IsFamily) {
    setShowPopUp(true);
  }
};


const changePrice = async (productsToChange, value) => {
  setSellingPrice(value);
  
  try {
    await Promise.all(
      productsToChange.map(async (prod) => {
        await setPrice(stationId, prod.Barcode, value);
        console.log(`Changed price for product ${prod.Barcode}`);
      })
    );
    console.log("All prices updated successfully");
  } catch (error) {
    console.error("Error updating prices:", error);
  }
};


  const handleSailChange = () => {
    const res = getSails(stationId);
    console.log(res);
  }


  return (
    <>
        <Container fluid>
          <Row className="price-row">
            <Col sm={2} className="text-center">
              <div className="field-group">
                <h4 className="field-label">מחיר קנייה:</h4>
                <input
                  type="number"
                  step="0.01"
                  className="number-input"
                />
              </div>
            </Col>
            <Col sm={2} className="text-center">
              <div className="field-group">
                <h4 className="field-label">מחיר מכירה:</h4>
                <input
                  type="number"
                  step="0.01"
                  value={sellingPrice}
                  onChange={(e) => handleSellingPriceChange(e.target.value)}
                  onClick={handleSellingPriceClick}
                  className="number-input"
                />
                <div className="checkbox-wrapper">
                  <input
                    type="checkbox"
                    checked={keepProfitMargin}
                    onChange={() => setKeepProfitMargin(!keepProfitMargin)}
                  />
                  <span>שמור על אחוז רווח</span>
                </div>
              </div>
            </Col>
            <Col sm={1} className="text-center">
              <div className="field-group">
                <h4 className="field-label">אחוז רווח:</h4>
                <input
                  type="number"
                  step="0.01"
                  className="number-input"
                />
              </div>
            </Col>
          </Row>

          <Row className="promo-row">
            <Col sm={2} className="text-center">
              <div className="field-group">
                <h4 className="field-label">מחיר מבצע:</h4>
                <input
                  type="number"
                  step="0.01"
                  className="number-input"
                  onChange={handleSailChange}
                />
              </div>
            </Col>
            <Col sm={4} className="text-center">
              <div className="field-group">
                <h4 className="field-label">תוקף מבצע:</h4>
                <div className="date-range-container">
                  <div className="date-field">
                    <input
                      type="date"
                      name="salestartDate"
                      className="date-input"
                    />
                  </div>
                  <span>עד</span>
                  <div className="date-field">
                    <input
                      type="date"
                      name="saleEndDate"
                      className="date-input"
                    />
                  </div>
                </div>
              </div>
            </Col>
            
          </Row>

          <Row className="date-row">
            <Col sm={6} className="text-center">
              <div className="field-group">
                <h4 className="field-label">תיאור מבצע:</h4>
                <textarea
                  className="promo-description"
                />
              </div>
            </Col>
          </Row>
          <Row className="quantity-row">
            <Col sm={1} className="text-center">
              <div className="field-group">
                <h4 className="field-label">הקצאת כמות למבצע:</h4>
                <input
                  type="number"
                  className="number-input"
                />
              </div>
            </Col>
            <Col sm={1} className="text-center">
              <div className="field-group">
                <h4 className="field-label">מינימום יחידות למחיר מבצע:</h4>
                <input
                  type="number"
                  className="number-input"
                />
              </div>
            </Col>
            <Col sm={1} className="text-center">
              <div className="field-group">
                <h4 className="field-label">הגבלת יחידות למבצע:</h4>
                <input
                  type="number"
                  className="number-input"
                />
              </div>
            </Col>
            <Col sm={1} className="text-center">
              <div className="field-group">
                <h4 className="field-label">הגבלת כמות לקוח לקנייה:</h4>
                <input
                  type="number"
                  className="number-input"
                />
              </div>
            </Col>
            <Col sm={1} className="text-center">
              <div className="field-group">
                <h4 className="field-label">הגבלת כמות במבצע ללקוח:</h4>
                <input
                  type="number"
                  className="number-input"
                />
              </div>
            </Col>
          </Row>      
          <Row className="xy-row">
            <Col sm={3}>
              <div className="field-group xy-container">
                <input
                  type="number"
                  className="xy-input"
                  placeholder="מספר יחידות"
                />
                <span>יחידות ב-</span>
                <input
                  type="number"
                  step="0.01"
                  className="xy-input"
                  placeholder="מחיר"
                />
                <span>ש"ח</span>
              </div>
            </Col>
          </Row>    
        </Container>
    {showPopUp && <FamilyChangeDialog product={product} close={setShowPopUp} onConfirm={changePrice}/>}
    </>
  );
};

export default ComparePricePopUp;